let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Y6LWX")).then(() => parcelRequire('fmCjX'));